import { Box, Typography } from "@bca/ui-library";
import { useRouter } from "next/router";
import React, { useCallback, useEffect } from "react";
import addFiltersToPageUrl from "./addFiltersToPageUrl";
import { FilterAsCheckbox } from "./FilterAsCheckbox";

let timer;

const getGroups = (filteredSubfilters) => {
  let groups = {};

  filteredSubfilters?.forEach(({ filterKey, filterValues }) => {
    let item = filterKey.split(" ");
    item.push(filterValues[0].count);
    const isOldRegPlate = item.length === 2;

    if (isOldRegPlate) {
      const oldRegPlateDetails = {
        name: item[0],
        count: item[1],
        group: "0",
        fullName: filterKey,
      };

      if (groups["0"]) {
        groups["0"].push(oldRegPlateDetails);
      } else {
        groups["0"] = [oldRegPlateDetails];
      }

      return;
    }

    const newRegPlateDetails = {
      name: item[1],
      count: item[2],
      group: item[0],
      fullName: filterKey,
    };
    const groupName = item[0].toString();

    if (groups[groupName]) {
      groups[groupName].push(newRegPlateDetails);
    } else {
      groups[groupName] = [newRegPlateDetails];
    }
  });

  return groups;
};

const PlateFacet = ({
  filteredSubfilters,
  appliedCheckboxes,
  setAppliedCheckboxes,
  setSelectedVehicles,
}) => {
  const categoryKey = "Plate";

  const router = useRouter();

  const stringifiedFilters = JSON.stringify(appliedCheckboxes);
  const debounceUrlUpdate = useCallback(() => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      const newUrl = addFiltersToPageUrl("bq", appliedCheckboxes);
      const currentPageUrl = new URL(window.location.href);
      if (newUrl.href === currentPageUrl.href) {
        return;
      }
      newUrl.searchParams.delete("page");
      newUrl.searchParams.delete("vrm");
      router.push(newUrl.href, newUrl.href, { shallow: true });
    }, 1000);
  }, [stringifiedFilters, appliedCheckboxes, router]);

  useEffect(() => {
    debounceUrlUpdate();
  }, [stringifiedFilters, debounceUrlUpdate]);

  const onChange = (filterKey, categoryKey) => {
    setSelectedVehicles([]);
    let newState = null;
    const filterAlreadyApplied = appliedCheckboxes.find(
      (item) =>
        item.filterKey.toLowerCase() === filterKey.toLowerCase() &&
        item.categoryKey.toLowerCase() === categoryKey.toLowerCase()
    );

    if (filterAlreadyApplied) {
      newState = [
        ...appliedCheckboxes.filter((item) => item !== filterAlreadyApplied),
      ];
    } else {
      newState = [
        ...appliedCheckboxes,
        {
          filterKey: filterKey,
          categoryKey,
          groupedBy: "",
          parentFilterKey: "",
        },
      ];
    }

    setAppliedCheckboxes([...newState]);
  };

  const groups = getGroups(filteredSubfilters);

  return (
    <Box key={filteredSubfilters?.filterKey}>
      <Typography fontSize={1} color="grey-blue" mt={5}>
        {filteredSubfilters?.filterKey}
      </Typography>
      {Object.keys(groups)
        .reverse()
        .map((key) => {
          return (
            <Box key={`${key}-group`}>
              {key !== "0" ? (
                <Typography color="footer-blue" fontWeight="500" mt="0px">
                  {key}
                </Typography>
              ) : (
                <Box height="30px" />
              )}
              {groups[key]?.map((filter) => (
                <FilterAsCheckbox
                  pl={filter.group !== "0" && "10px"}
                  key={`${categoryKey}-${filter.fullName}`}
                  id={filter.fullName}
                  label={filter.name}
                  resultsCount={filter.count}
                  isSelected={Boolean(
                    appliedCheckboxes.find(
                      (item) =>
                        item.filterKey.toLowerCase() ===
                          filter.fullName.toLowerCase() &&
                        item.categoryKey.toLowerCase() ===
                          categoryKey.toLowerCase()
                    )
                  )}
                  onChange={() => onChange(filter.fullName, categoryKey)}
                />
              ))}
            </Box>
          );
        })}
    </Box>
  );
};

export default PlateFacet;
